import { compact } from '../../../../helpers/compact';
import { HomeSliceType, SelectedPostsSlice } from '../../../../types/slice';
import { toText } from '../../fields';
import homeTile from './home-tile';

const selectedPostsSlice = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): SelectedPostsSlice | undefined => {
  if (data.primary?.enabled !== 'oui') {
    return undefined;
  }

  const title = toText(data.primary?.title);
  if (!title) {
    return undefined;
  }

  return compact({
    type: HomeSliceType.SELECTED_POSTS,
    title,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tiles: data.items.map((post: any) => homeTile(post)),
  });
};

export default selectedPostsSlice;
